import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { NotificationHandlerComponent, UtilitiesModule } from '@ebootis/utilities';
import { TranslateModule } from '@ngx-translate/core';
import { ArticleModule } from '../article/article.module';
import { CustomerModule } from '../customer/customer.module';
import { SharedModule } from '../shared/shared.module';
import { OrderCreateComponent } from './components/order-create/order-create.component';
import { OrderDetailDialogComponent } from './components/order-detail-dialog/order-detail.dialog.component';
import { OrderDetailComponent } from './components/order-detail/order-detail.component';
import { OrderPrintComponent } from './components/order-print/order-print.component';
import { OrderSearchComponent } from './components/order-search/order-search.component';
import { OrderTableComponent } from './components/order-table/order-table.component';
import { OrderComponent } from './components/order/order.component';

@NgModule({
    declarations: [OrderComponent, OrderSearchComponent, OrderDetailComponent, OrderCreateComponent, OrderTableComponent, OrderDetailDialogComponent, OrderPrintComponent],
    imports: [
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        MatTabsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatOptionModule,
        MatSelectModule,
        MatButtonModule,
        MatTableModule,
        MatIconModule,
        MatPaginatorModule,
        MatCardModule,
        MatTooltipModule,
        MatRadioModule,
        MatStepperModule,
        MatCheckboxModule,
        MatSortModule,
        TranslateModule.forChild(),
        CustomerModule,
        SharedModule,
        ArticleModule,
        MatSnackBarModule,
        UtilitiesModule,
        MatDialogModule
    ],
    exports: [
        OrderTableComponent,
        OrderDetailComponent,
        OrderPrintComponent
    ],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true }
        }
    ]
})
export class OrderModule { }
